import { IStipoProcesso, TipoProcesso } from "../tipoProcesso/TipoProcesso";
import { ISusuarioList, UsuarioList } from "../usuario/UsuarioList";
import { Documento } from "./Documento";
import { ISprocesso, Processo } from "./Processo";

export interface ProcessoAtualizaAndamento {
    id: string;
    descricao: string;
    usuario: UsuarioList;
    dataHoraCriacao: Date | null;
    processo: Processo;   
}

export const ISprocessoAtualizaAndamento: ProcessoAtualizaAndamento = {
    id: "",
    descricao: "",
    usuario: ISusuarioList,
    dataHoraCriacao: null,
    processo: ISprocesso,
}